import {WithoutSummaryModel} from '../../../../common/entity/dto/plain/withoutSummary.model';
import {LovValueSummary} from "../../../../common/lov/lov-value/api/model/lovValueSummary.model";

export class CommunicationContentSubstitutionModel extends WithoutSummaryModel{
    name: string;
    textToReplace: string;
    active: boolean;
    category: LovValueSummary;
    businessContext: LovValueSummary;
    businessContextLabel: string;
}
